<form [formGroup]="form.formGroup">
  <div class="flex flex-col space-y-2">

    <div class="flex space-x-2">
        <div>
          <label>Description:</label>
          <i 
            class="pi pi-info-circle cursor-help pl-1" 
            pTooltip="This EPP applies the mud/fluid hydrostatic to TOC of the current casing and applies Pore Pressure for cement sections in the open hole.&#13;If TOC is above the previous shoe, then cement mix-water gradient is applied from TOC to previous shoe depth."
          ></i>
        </div>
    </div>

    <app-general-epp
      [formControlName]="form.formControlNames.generalEpp"
      [currentString]="currentString"
      [userUnits]="userUnits"
      [loadCaseIndex]="loadCaseIndex"
    ></app-general-epp>

    <div class="flex flex-col">
      <label>Cement Mix-Water Density</label>
      <app-validated-number-input
        [id]="'cementMixwaterDensity'"
        [control]="control('cementMixwaterDensity')"
        [value]="control('cementMixwaterDensity').value"
        [validation]="densityValidation"
        [unit]="densityLabel"
      ></app-validated-number-input>
    </div>
    
    <app-gas-cap
      hidden="true"
      [formControlName]="form.formControlNames.gasCap"
      [userUnits]="userUnits"
      [currentString]="currentString"
    ></app-gas-cap>
    
    @if (form.formGroup.hasError('porePressureNotSpecified')) {
      <p class="validation-error">
        Pore Pressure profile not specified.
      </p>
    }

    @if (
      form.formGroup.hasError('porePressureMustBeToShoe') &&
      !form.formGroup.hasError('porePressureNotSpecified')
    ) {
      <p class="validation-error">
        Pore Pressure profile must be extended to the shoe of the string.
      </p>
    }
    
    <p class="text-sm">
      Mud Weight: &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
      {{ currentString?.annularFluid.state.nominalDensity.toFixed(2) }} {{ densityLabel }}
    </p>

  </div>
</form>
